const translations = {
  pt: {
    nav: {
      tag: "// DEV & CYBER",
      openToWork: "DISPONÍVEL PARA TRABALHO",
      home: "HOME",
      about: "SOBRE",
      projects: "PROJETOS",
      cyber: "SEGURANÇA",
      stack: "STACK",
      experience: "EXPERIÊNCIA",
      resume: "CURRÍCULO",
    },
    home: {
      eyebrow: "FULL STACK • CIBERSEGURANÇA • APIs REST",
      titleGlitch1: "DEVELOPER FULL STACK",
      titleGlitch2: "& CYBER",
      subtitle:
        "Interfaces, APIs e ferramentas de segurança — projetadas entre estágio, faculdade e curiosidade com o mundo do cyber. Focado em construir soluções eficientes, escaláveis e seguras.",
      downloadCv: "DOWNLOAD CV",
      viewProjects: "VER PROJETOS",
      cyberLabBtn: ">_ CYBER LAB",
      location: "Brasília, DF",
      whoami: {
        dev: "Samuel Barbosa",
        role: "Full-Stack & Cyber",
        stack: "Go, TypeScript, Node, React",
        infra: "Linux, Docker, Kali Linux",
        cyber: "OSINT & Criptografia",
        status: "Pronto para construir 🚀",
      },
      stats: {
        yearsStudying: "Anos Estudando TI",
        projectsDeveloped: "Projetos Desenvolvidos",
        certifications: "Certificações",
        yearsExperience: "Ano de Exp. em TI",
      },
    },
    typewriter: [
      "Desenvolvedor Backend",
      "Estudante de Cibersegurança",
      "Go & Shell Script Enthusiast",
      "Contribuidor Open Source",
    ],
    home2: {
      comment1: "/* um pouco sobre mim */",
      comment2: "quem está por trás do código",
      num: "01.",
      title: "O Que Eu Faço",
      growingEyebrow: ">_ PROFISSIONAL EM CRESCIMENTO CONTÍNUO",
      bio: "Sou Samuel Barbosa, tenho experiência prática em suporte técnico, resolução de incidentes e automação de processos. Atualmente em transição e especialização em Desenvolvimento Full-Stack e Cibersegurança. Com curiosidade como motor, código como ferramenta e Linux como ambiente favorito.",
      helpTitle: "Como posso ajudar",
      helpList: [
        "Suporte N1 com foco em SLA e diagnóstico",
        "Desenvolvimento de APIs em Go & Node.js",
        "Automação de tarefas e scripts Shell Linux",
      ],
      workStyleTitle: "Minha forma de trabalho",
      workStyleList: [
        "Foco em SLA, qualidade e documentação",
        "Comunicação clara e objetiva",
        "Resolução estruturada de incidentes",
      ],
      service1: {
        title: "Suporte Técnico N1",
        desc: "Service Desk, gerenciamento de chamados, ITSM, Active Directory, Citrix VDI e diagnóstico estruturado de incidentes.",
      },
      service2: {
        title: "Desenvolvimento Full-Stack",
        desc: "APIs REST eficientes em Go/Node.js, aplicações web com TypeScript, React Native e bancos SQL.",
      },
      service3: {
        title: "Infraestrutura & Cyber",
        desc: "Ambientes Linux/Windows, Docker, Shell scripts, Kali Linux, VPN, DNS, OSINT e cibersegurança.",
      },
    },
    about: {
      comment1: "/* stack & habilidades */",
      comment2: "o que eu domino",
      title1: "Tech Stack & Habilidades",
      title1Colored: "Stack",
      subtitle1:
        "Tecnologias que utilizo para desenvolvimento, infraestrutura e estudos de cibersegurança.",
      title2: "Tecnologias & Ferramentas",
      title2Colored: "Tecnologias",
      title3: "Ferramentas de Trabalho & Lab",
      title3Colored: "Ferramentas",
    },
    aboutCard: {
      greeting: "Olá! Eu sou Samuel Barbosa, de Brasília, Brasil.",
      p1: "Atualmente estudo TI e estou me especializando em Desenvolvimento Backend (Go) e Cibersegurança.",
      p2: "Tenho grande entusiasmo por construir arquiteturas resilientes, scripts de automação para Kali Linux, ferramentas de criptografia e explorar como defender sistemas contra ameaças cibernéticas.",
      hobbiesTitle: "Além de codificar e estudar cibersegurança, também gosto de:",
      hobbies: [
        "Pesquisar vulnerabilidades & praticar laboratórios de Segurança",
        "Desenvolver APIs eficientes e concisas em Golang",
        "Automatizar rotas de manutenção no Linux (Shell Script)",
      ],
      quote:
        '"Entender como as coisas quebram é o melhor caminho para aprender a construí-las de forma segura."',
    },
    experience: {
      comment1: "/* trajetória */",
      comment2: "experiência & formação",
      num1: "04.",
      title1: "Experiência Profissional",
      num2: "05.",
      title2: "Formação Acadêmica",
      commentCerts1: "/* certificações */",
      commentCerts2: "qualificações e competências",
      num3: "06.",
      title3: "Certificações",
      jobs: [
        {
          role: "Trainee TI",
          company: "Ensti — Brasília, DF",
          period: "02/2026 – atualmente",
          details: [
            "Suporte técnico especializado ao sistema SICLUS (ERP)",
            "Atendimento e suporte aos módulos administrativos",
            "Registro, acompanhamento e resolução de chamados técnicos",
            "Interface de comunicação entre usuários e a área técnica de desenvolvimento",
          ],
        },
        {
          role: "Agente de Service Desk",
          company: "Sonda (Make IT Easy) — Brasília, DF",
          period: "01/2025 – 11/2025",
          details: [
            "Suporte N1 utilizando ServiceNow e Active Directory",
            "Acesso remoto, suporte a Citrix VDI e diagnóstico inicial",
            "Tratamento e resolução de incidentes em sistemas Windows e Linux",
            "Cumprimento rigoroso de SLA e métricas de qualidade de atendimento",
          ],
        },
      ],
      edu: [
        {
          title: "Tecnólogo em Análise e Desenvolvimento de Sistemas",
          institution: "Faculdade UDF — Brasília, DF",
          period: "2025 – 2027 (Previsto)",
          details: [
            "Engenharia de software e arquitetura de sistemas",
            "Desenvolvimento web, mobile e modelagem de banco de dados",
            "Metodologias ágeis e boas práticas de código limpo",
          ],
        },
        {
          title: "Desenvolvimento FullStack & Microsserviços",
          institution: "Alura / FIAP / Cisco / SENAI",
          period: "2023 – Contínuo",
          details: [
            "JavaScript, TypeScript e React Native (Alura)",
            "Linux, Cybersecurity, Cloud e DevOps (FIAP)",
            "Fundamentos de Redes e CCNA (Cisco)",
            "Desenvolvedor C# (SENAI)",
            "Docker e Gestão de Infraestrutura de TI",
          ],
        },
      ],
    },
    projects: {
      comment1: "/* portfólio & repositórios */",
      comment2: "projetos reais no GitHub",
      title: "Meus Projetos Reais",
      titleColored: "Reais",
      subtitle:
        "Repositórios do GitHub focados em Cibersegurança, Backend em Go e Aplicações Web/Mobile.",
      filterAll: "Todos",
      filterCyber: "Cibersegurança",
      filterBackend: "Backend & Go",
      filterWeb: "Web & Mobile",
      moreGithub: "Ver mais no GitHub →",
      list: {
        conhesiclus: {
          title: "ConheSiclus",
          desc: "Plataforma de base de conhecimento (KB/FAQ) desenvolvida para organizar e exibir informações de forma rápida e intuitiva.",
        },
        dayflow: {
          title: "DayFlow",
          desc: "Aplicativo de gerenciamento de tarefas minimalista e eficiente em React Native com Expo e TypeScript. Interface moderna em dark mode.",
        },
        osint: {
          title: "Painel OSINT Completo",
          desc: "Automação de reconhecimento e inteligência em segurança. Painel completo para OSINT em ambientes Linux.",
        },
        kali: {
          title: "atualiza-o_kali-linux",
          desc: "Script de automação em Shell para manutenção, atualização de pacotes de pentest e otimização do sistema Kali Linux.",
        },
        crypto: {
          title: "Criptografia em Go",
          desc: "Implementação de algoritmos criptográficos, funções de hashing e conceitos de segurança da informação desenvolvidos em Golang.",
        },
        filmes: {
          title: "filmesAPI",
          desc: "API RESTful construída em Golang para gerenciamento de catálogos de filmes, rotas eficientes e estrutura robusta de dados.",
        },
        gym: {
          title: "ObsidianGym",
          desc: "Interface web interativa em React.js para visualização de planos, treinos e informações da academia Obsidian Gym.",
        },
        ensti: {
          title: "Ensti-TI",
          desc: "Portal web institucional voltado a tecnologias e serviços de TI, otimizado para navegação moderna e responsiva.",
        },
      },
    },
    cyberlab: {
      comment1: "/* cybersecurity & research */",
      comment2: "ferramentas e laboratório",
      title: "Laboratório de Cibersegurança",
      titleColored: "Cibersegurança",
      subtitle:
        "Ferramentas, scripts de automação Linux, algoritmos de criptografia e práticas de defesa & teste.",
      viewRepo: "Ver Repositório",
      explore: "Explorar",
      cards: {
        kaliTitle: "Automação Kali Linux",
        kaliDesc:
          "Desenvolvo scripts Shell para manutenção automatizada, atualização de pacotes e preparação de ambientes de auditoria no Kali Linux.",
        cryptoTitle: "Criptografia Go",
        cryptoDesc:
          "Algoritmos criptográficos, hashing seguro e conceitos de chave pública/privada em Golang.",
        osintTitle: "Painel OSINT",
        osintDesc:
          "Automação de reconhecimento e inteligência de fontes abertas para ambientes Linux.",
        appsecTitle: "AppSec",
        appsecDesc:
          "OWASP Top 10, sanitização de inputs, prevenção SQLi/XSS e autenticação segura JWT/OAuth.",
        netTitle: "Networking",
        netDesc:
          "TCP/IP, análise de pacotes com Wireshark, permissões de sistema e controle de acessos Linux.",
      },
    },
    footer: {
      comment1: "/* contato */",
      comment2: "vamos conversar?",
      bio: "Full-Stack Developer & Especialista em Suporte TI. Focado em soluções robustas em Golang, TypeScript e Cibersegurança.",
      status: "DISPONÍVEL PARA OPORTUNIDADES",
      directContact: "Contato Direto",
      location: "Brasília, DF — Brasil",
      networksLinks: "Redes & Links",
      backToTop: "Voltar ao Topo",
      rights: "Samuel Barbosa. Todos os direitos reservados.",
    },
    terminal: {
      placeholder: "digite um comando...",
      btnTooltip: "Pressione /",
      btnAria: "Abrir terminal",
      title: "samuel@kali:~ (Terminal)",
      welcomeTitle: "SAMUEL.OS v4.19-kali — Terminal Interativo",
      welcomeMsg: 'Digite "help" para ver os comandos disponíveis.',
      commands: {
        help: "Mostrar comandos disponíveis",
        whoami: "Quem é Samuel Barbosa",
        projetos: "Ir para seção de projetos",
        seguranca: "Ir para seção de segurança",
        skills: "Ir para stack & habilidades",
        experiencia: "Ir para experiência",
        contato: "Ir para contato",
        github: "Abrir GitHub",
        linkedin: "Abrir LinkedIn",
        clear: "Limpar terminal",
      },
      navMessages: {
        projetos: "[+] Navegando para seção de projetos...",
        seguranca: "[+] Navegando para Cyber Lab...",
        skills: "[+] Navegando para Stack & Habilidades...",
        experiencia: "[+] Navegando para Experiência...",
        contato: "[+] Navegando para Contato...",
        github: "[+] Abrindo GitHub... github.com/SamuelBarbosa1",
        linkedin: "[+] Abrindo LinkedIn...",
      },
      easterEggPermission: "🔓 [SUDO] Permissão concedida!",
      easterEggBanner: "🎉 ACESSO CONCEDIDO COM SUCESSO! 🎉",
      easterEggText1: "Samuel Barbosa está disponível para",
      easterEggText2: "novas oportunidades em Full-Stack",
      easterEggText3: "Development & Cybersecurity.",
      easterEggRedirect: "Redirecionando para contato...",
      notFound: '[-] Comando não encontrado: ',
      typeHelp: '    Digite "help" para ver comandos disponíveis.',
    },
  },
  en: {
    nav: {
      tag: "// DEV & CYBER",
      openToWork: "OPEN TO WORK",
      home: "HOME",
      about: "ABOUT",
      projects: "PROJECTS",
      cyber: "SECURITY",
      stack: "STACK",
      experience: "EXPERIENCE",
      resume: "RESUME",
    },
    home: {
      eyebrow: "FULL STACK • CYBERSECURITY • REST APIs",
      titleGlitch1: "DEVELOPER FULL STACK",
      titleGlitch2: "& CYBER",
      subtitle:
        "Interfaces, APIs, and security tools — crafted across internships, college, and cybersecurity curiosity. Focused on building efficient, scalable, and secure solutions.",
      downloadCv: "DOWNLOAD CV",
      viewProjects: "VIEW PROJECTS",
      cyberLabBtn: ">_ CYBER LAB",
      location: "Brasília, DF",
      whoami: {
        dev: "Samuel Barbosa",
        role: "Full-Stack & Cyber",
        stack: "Go, TypeScript, Node, React",
        infra: "Linux, Docker, Kali Linux",
        cyber: "OSINT & Cryptography",
        status: "Ready to build 🚀",
      },
      stats: {
        yearsStudying: "Years Studying IT",
        projectsDeveloped: "Projects Developed",
        certifications: "Certifications",
        yearsExperience: "Year of IT Exp.",
      },
    },
    typewriter: [
      "Backend Developer",
      "Cybersecurity Student",
      "Go & Shell Script Enthusiast",
      "Open Source Contributor",
    ],
    home2: {
      comment1: "/* a little about me */",
      comment2: "who is behind the code",
      num: "01.",
      title: "What I Do",
      growingEyebrow: ">_ CONTINUOUSLY GROWING PROFESSIONAL",
      bio: "I'm Samuel Barbosa, with practical experience in technical support, incident resolution, and process automation. Currently transitioning into and specializing in Full-Stack Development and Cybersecurity. Curiosity is my engine, code is my tool, and Linux is my favorite environment.",
      helpTitle: "How I can help",
      helpList: [
        "L1 Support focused on SLA and diagnostics",
        "API Development in Go & Node.js",
        "Task automation and Linux Shell scripts",
      ],
      workStyleTitle: "My way of working",
      workStyleList: [
        "Focus on SLA, quality, and documentation",
        "Clear and concise communication",
        "Structured incident resolution",
      ],
      service1: {
        title: "Technical Support L1",
        desc: "Service Desk, ticket management, ITSM, Active Directory, Citrix VDI, and structured incident diagnostics.",
      },
      service2: {
        title: "Full-Stack Development",
        desc: "Efficient REST APIs in Go/Node.js, web applications with TypeScript, React Native, and SQL databases.",
      },
      service3: {
        title: "Infrastructure & Cyber",
        desc: "Linux/Windows environments, Docker, Shell scripts, Kali Linux, VPN, DNS, OSINT, and cybersecurity.",
      },
    },
    about: {
      comment1: "/* stack & skills */",
      comment2: "what I master",
      title1: "Tech Stack & Skills",
      title1Colored: "Stack",
      subtitle1:
        "Technologies I use for development, infrastructure, and cybersecurity research.",
      title2: "Technologies & Tools",
      title2Colored: "Technologies",
      title3: "Work Tools & Lab",
      title3Colored: "Tools",
    },
    aboutCard: {
      greeting: "Hello! I'm Samuel Barbosa, from Brasília, Brazil.",
      p1: "Currently studying IT and specializing in Backend Development (Go) and Cybersecurity.",
      p2: "I am passionate about building resilient architectures, automation scripts for Kali Linux, cryptography tools, and exploring how to defend systems against cyber threats.",
      hobbiesTitle: "Besides coding and studying cybersecurity, I also enjoy:",
      hobbies: [
        "Researching vulnerabilities & practicing security labs",
        "Building efficient and concise APIs in Golang",
        "Automating Linux maintenance tasks (Shell Script)",
      ],
      quote:
        '"Understanding how things break is the best path to learning how to build them securely."',
    },
    experience: {
      comment1: "/* trajectory */",
      comment2: "experience & education",
      num1: "04.",
      title1: "Professional Experience",
      num2: "05.",
      title2: "Academic Background",
      commentCerts1: "/* certifications */",
      commentCerts2: "qualifications and skills",
      num3: "06.",
      title3: "Certifications",
      jobs: [
        {
          role: "IT Trainee",
          company: "Ensti — Brasília, DF",
          period: "02/2026 – present",
          details: [
            "Specialized technical support for the SICLUS ERP system",
            "Support and assistance for administrative modules",
            "Ticket registration, tracking, and technical resolution",
            "Communication interface between users and development team",
          ],
        },
        {
          role: "Service Desk Agent",
          company: "Sonda (Make IT Easy) — Brasília, DF",
          period: "01/2025 – 11/2025",
          details: [
            "L1 Support using ServiceNow and Active Directory",
            "Remote access, Citrix VDI support, and initial triage",
            "Incident resolution across Windows and Linux environments",
            "Strict compliance with SLAs and quality service metrics",
          ],
        },
      ],
      edu: [
        {
          title: "Associate Degree in Systems Analysis & Development",
          institution: "Faculdade UDF — Brasília, DF",
          period: "2025 – 2027 (Expected)",
          details: [
            "Software engineering and systems architecture",
            "Web, mobile development, and database modeling",
            "Agile methodologies and clean code practices",
          ],
        },
        {
          title: "FullStack Development & Microservices",
          institution: "Alura / FIAP / Cisco / SENAI",
          period: "2023 – Ongoing",
          details: [
            "JavaScript, TypeScript, and React Native (Alura)",
            "Linux, Cybersecurity, Cloud, and DevOps (FIAP)",
            "Networking Fundamentals and CCNA (Cisco)",
            "C# Developer (SENAI)",
            "Docker and IT Infrastructure Management",
          ],
        },
      ],
    },
    projects: {
      comment1: "/* portfolio & repositories */",
      comment2: "real projects on GitHub",
      title: "My Real Projects",
      titleColored: "Projects",
      subtitle:
        "GitHub repositories focused on Cybersecurity, Go Backend, and Web/Mobile applications.",
      filterAll: "All",
      filterCyber: "Cybersecurity",
      filterBackend: "Backend & Go",
      filterWeb: "Web & Mobile",
      moreGithub: "View more on GitHub →",
      list: {
        conhesiclus: {
          title: "ConheSiclus",
          desc: "Knowledge base platform (KB/FAQ) built to organize and display information quickly and intuitively.",
        },
        dayflow: {
          title: "DayFlow",
          desc: "Minimalist and efficient task management mobile app built with React Native, Expo, and TypeScript in dark mode.",
        },
        osint: {
          title: "Full OSINT Panel",
          desc: "Reconnaissance and security intelligence automation. Comprehensive OSINT panel for Linux environments.",
        },
        kali: {
          title: "atualiza-o_kali-linux",
          desc: "Shell automation script for system maintenance, pentest package updates, and Kali Linux optimization.",
        },
        crypto: {
          title: "Cryptography in Go",
          desc: "Implementation of cryptographic algorithms, hashing functions, and information security concepts built in Golang.",
        },
        filmes: {
          title: "filmesAPI",
          desc: "RESTful API built in Golang for movie catalog management, featuring efficient routing and robust data structures.",
        },
        gym: {
          title: "ObsidianGym",
          desc: "Interactive React.js web interface for viewing plans, workouts, and gym info for Obsidian Gym.",
        },
        ensti: {
          title: "Ensti-TI",
          desc: "Institutional web portal focused on IT services and technologies, optimized for responsive modern browsing.",
        },
      },
    },
    cyberlab: {
      comment1: "/* cybersecurity & research */",
      comment2: "tools and lab",
      title: "Cybersecurity Lab",
      titleColored: "Cybersecurity",
      subtitle:
        "Tools, Linux automation scripts, cryptographic algorithms, and security testing practices.",
      viewRepo: "View Repository",
      explore: "Explore",
      cards: {
        kaliTitle: "Kali Linux Automation",
        kaliDesc:
          "Shell scripts for automated maintenance, package upgrades, and audit environment setups on Kali Linux.",
        cryptoTitle: "Go Cryptography",
        cryptoDesc:
          "Cryptographic algorithms, secure hashing, and public/private key principles in Golang.",
        osintTitle: "OSINT Panel",
        osintDesc:
          "Automation for open-source intelligence gathering and reconnaissance in Linux environments.",
        appsecTitle: "AppSec",
        appsecDesc:
          "OWASP Top 10, input sanitization, SQLi/XSS prevention, and secure JWT/OAuth authentication.",
        netTitle: "Networking",
        netDesc:
          "TCP/IP, Wireshark packet analysis, system permissions, and Linux access control.",
      },
    },
    footer: {
      comment1: "/* contact */",
      comment2: "let's talk?",
      bio: "Full-Stack Developer & IT Support Specialist. Focused on robust solutions in Golang, TypeScript, and Cybersecurity.",
      status: "AVAILABLE FOR OPPORTUNITIES",
      directContact: "Direct Contact",
      location: "Brasília, DF — Brazil",
      networksLinks: "Social & Links",
      backToTop: "Back to Top",
      rights: "Samuel Barbosa. All rights reserved.",
    },
    terminal: {
      placeholder: "type a command...",
      btnTooltip: "Press /",
      btnAria: "Open terminal",
      title: "samuel@kali:~ (Terminal)",
      welcomeTitle: "SAMUEL.OS v4.19-kali — Interactive Terminal",
      welcomeMsg: 'Type "help" to see available commands.',
      commands: {
        help: "Show available commands",
        whoami: "Who is Samuel Barbosa",
        projetos: "Go to projects section",
        seguranca: "Go to security section",
        skills: "Go to stack & skills",
        experiencia: "Go to experience",
        contato: "Go to contact",
        github: "Open GitHub",
        linkedin: "Open LinkedIn",
        clear: "Clear terminal",
      },
      navMessages: {
        projetos: "[+] Navigating to projects section...",
        seguranca: "[+] Navigating to Cyber Lab...",
        skills: "[+] Navigating to Stack & Skills...",
        experiencia: "[+] Navigating to Experience...",
        contato: "[+] Navigating to Contact...",
        github: "[+] Opening GitHub... github.com/SamuelBarbosa1",
        linkedin: "[+] Opening LinkedIn...",
      },
      easterEggPermission: "🔓 [SUDO] Permission granted!",
      easterEggBanner: "🎉 ACCESS GRANTED SUCCESSFULLY! 🎉",
      easterEggText1: "Samuel Barbosa is available for",
      easterEggText2: "new opportunities in Full-Stack",
      easterEggText3: "Development & Cybersecurity.",
      easterEggRedirect: "Redirecting to contact...",
      notFound: '[-] Command not found: ',
      typeHelp: '    Type "help" to view available commands.',
    },
  },
  es: {
    nav: {
      tag: "// DEV & CYBER",
      openToWork: "DISPONIBLE PARA TRABAJAR",
      home: "INICIO",
      about: "SOBRE MÍ",
      projects: "PROYECTOS",
      cyber: "SEGURIDAD",
      stack: "STACK",
      experience: "EXPERIENCIA",
      resume: "CURRÍCULUM",
    },
    home: {
      eyebrow: "FULL STACK • CIBERSEGURIDAD • APIs REST",
      titleGlitch1: "DEVELOPER FULL STACK",
      titleGlitch2: "& CYBER",
      subtitle:
        "Interfaces, APIs y herramientas de seguridad — diseñadas entre prácticas, universidad y curiosidad por el mundo cibernético. Enfocado en construir soluciones eficientes, escalables y seguras.",
      downloadCv: "DESCARGAR CV",
      viewProjects: "VER PROYECTOS",
      cyberLabBtn: ">_ CYBER LAB",
      location: "Brasilia, DF",
      whoami: {
        dev: "Samuel Barbosa",
        role: "Full-Stack & Cyber",
        stack: "Go, TypeScript, Node, React",
        infra: "Linux, Docker, Kali Linux",
        cyber: "OSINT y Criptografía",
        status: "Listo para construir 🚀",
      },
      stats: {
        yearsStudying: "Años Estudiano TI",
        projectsDeveloped: "Proyectos Desarrollados",
        certifications: "Certificaciones",
        yearsExperience: "Año de Exp. en TI",
      },
    },
    typewriter: [
      "Desarrollador Backend",
      "Estudiante de Ciberseguridad",
      "Entusiasta de Go y Shell Script",
      "Colaborador Open Source",
    ],
    home2: {
      comment1: "/* un poco sobre mí */",
      comment2: "quién está detrás del código",
      num: "01.",
      title: "Lo Que Hago",
      growingEyebrow: ">_ PROFESIONAL EN CRECIMIENTO CONTINUO",
      bio: "Soy Samuel Barbosa, cuento con experiencia práctica en soporte técnico, resolución de incidentes y automatización de procesos. Actualmente en transición y especialización en Desarrollo Full-Stack y Ciberseguridad. La curiosidad es mi motor, el código mi herramienta y Linux mi entorno favorito.",
      helpTitle: "Cómo puedo ayudar",
      helpList: [
        "Soporte N1 enfocado en SLA y diagnóstico",
        "Desarrollo de APIs en Go y Node.js",
        "Automatización de tareas y scripts Shell Linux",
      ],
      workStyleTitle: "Mi forma de trabajo",
      workStyleList: [
        "Enfoque en SLA, calidad y documentación",
        "Comunicación clara y objetiva",
        "Resolución estructurada de incidentes",
      ],
      service1: {
        title: "Soporte Técnico N1",
        desc: "Service Desk, gestión de tickets, ITSM, Active Directory, Citrix VDI y diagnóstico estructurado de incidentes.",
      },
      service2: {
        title: "Desarrollo Full-Stack",
        desc: "APIs REST eficientes en Go/Node.js, aplicaciones web con TypeScript, React Native y bases de datos SQL.",
      },
      service3: {
        title: "Infraestructura & Cyber",
        desc: "Entornos Linux/Windows, Docker, Shell scripts, Kali Linux, VPN, DNS, OSINT y ciberseguridad.",
      },
    },
    about: {
      comment1: "/* stack & habilidades */",
      comment2: "lo que domino",
      title1: "Tech Stack y Habilidades",
      title1Colored: "Stack",
      subtitle1:
        "Tecnologías que utilizo para desarrollo, infraestructura y estudios de ciberseguridad.",
      title2: "Tecnologías y Herramientas",
      title2Colored: "Tecnologías",
      title3: "Herramientas de Trabajo & Lab",
      title3Colored: "Herramientas",
    },
    aboutCard: {
      greeting: "¡Hola! Soy Samuel Barbosa, de Brasilia, Brasil.",
      p1: "Actualmente estudio TI y me estoy especializando en Desarrollo Backend (Go) y Ciberseguridad.",
      p2: "Me apasiona construir arquitecturas resilientes, scripts de automatización para Kali Linux, herramientas de criptografía y explorar cómo defender sistemas contra ciberamenazas.",
      hobbiesTitle: "Además de programar y estudiar ciberseguridad, también disfruto de:",
      hobbies: [
        "Investigar vulnerabilidades y practicar en laboratorios de seguridad",
        "Desarrollar APIs eficientes y concisas en Golang",
        "Automatizar tareas de mantenimiento en Linux (Shell Script)",
      ],
      quote:
        '"Entender cómo se rompen las cosas es el mejor camino para aprender a construirlas de forma segura."',
    },
    experience: {
      comment1: "/* trayectoria */",
      comment2: "experiencia y formación",
      num1: "04.",
      title1: "Experiencia Profesional",
      num2: "05.",
      title2: "Formación Académica",
      commentCerts1: "/* certificaciones */",
      commentCerts2: "calificaciones y competencias",
      num3: "06.",
      title3: "Certificaciones",
      jobs: [
        {
          role: "Trainee de TI",
          company: "Ensti — Brasilia, DF",
          period: "02/2026 – actualmente",
          details: [
            "Soporte técnico especializado al sistema SICLUS (ERP)",
            "Atención y soporte a los módulos administrativos",
            "Registro, seguimiento y resolución de tickets técnicos",
            "Interfaz de comunicación entre usuarios y equipo técnico de desarrollo",
          ],
        },
        {
          role: "Agente de Service Desk",
          company: "Sonda (Make IT Easy) — Brasilia, DF",
          period: "01/2025 – 11/2025",
          details: [
            "Soporte N1 utilizando ServiceNow y Active Directory",
            "Acceso remoto, soporte a Citrix VDI y diagnóstico inicial",
            "Atención y resolución de incidentes en sistemas Windows y Linux",
            "Cumplimiento riguroso de SLAs y métricas de calidad",
          ],
        },
      ],
      edu: [
        {
          title: "Técnico Superior en Análisis y Desarrollo de Sistemas",
          institution: "Faculdade UDF — Brasilia, DF",
          period: "2025 – 2027 (Previsto)",
          details: [
            "Ingeniería de software y arquitectura de sistemas",
            "Desarrollo web, móvil y modelado de bases de datos",
            "Metodologías ágiles y buenas prácticas de código limpio",
          ],
        },
        {
          title: "Desarrollo FullStack y Microservicios",
          institution: "Alura / FIAP / Cisco / SENAI",
          period: "2023 – En curso",
          details: [
            "JavaScript, TypeScript y React Native (Alura)",
            "Linux, Ciberseguridad, Cloud y DevOps (FIAP)",
            "Fundamentos de Redes y CCNA (Cisco)",
            "Desarrollador C# (SENAI)",
            "Docker y Gestión de Infraestructura de TI",
          ],
        },
      ],
    },
    projects: {
      comment1: "/* portafolio & repositorios */",
      comment2: "proyectos reales en GitHub",
      title: "Mis Proyectos Reales",
      titleColored: "Reales",
      subtitle:
        "Repositorios de GitHub enfocados en Ciberseguridad, Backend en Go y Aplicaciones Web/Mobile.",
      filterAll: "Todos",
      filterCyber: "Ciberseguridad",
      filterBackend: "Backend & Go",
      filterWeb: "Web & Mobile",
      moreGithub: "Ver más en GitHub →",
      list: {
        conhesiclus: {
          title: "ConheSiclus",
          desc: "Plataforma de base de conocimiento (KB/FAQ) desarrollada para organizar y mostrar información de forma rápida e intuitiva.",
        },
        dayflow: {
          title: "DayFlow",
          desc: "Aplicación móvil de gestión de tareas minimalista y eficiente en React Native con Expo y TypeScript en dark mode.",
        },
        osint: {
          title: "Panel OSINT Completo",
          desc: "Automatización de reconocimiento e inteligencia de seguridad. Panel completo para OSINT en entornos Linux.",
        },
        kali: {
          title: "atualiza-o_kali-linux",
          desc: "Script de automatización en Shell para mantenimiento, actualización de paquetes de pentest y optimización de Kali Linux.",
        },
        crypto: {
          title: "Criptografía en Go",
          desc: "Implementación de algoritmos criptográficos, funciones de hash y conceptos de seguridad desarrollados en Golang.",
        },
        filmes: {
          title: "filmesAPI",
          desc: "API RESTful construida en Golang para gestión de catálogos de películas, rutas eficientes y estructura de datos robusta.",
        },
        gym: {
          title: "ObsidianGym",
          desc: "Interfaz web interactiva en React.js para ver planes, entrenamientos e información del gimnasio Obsidian Gym.",
        },
        ensti: {
          title: "Ensti-TI",
          desc: "Portal web institucional enfocado en tecnologías y servicios de TI, optimizado para navegación moderna y responsiva.",
        },
      },
    },
    cyberlab: {
      comment1: "/* cybersecurity & research */",
      comment2: "herramientas y laboratorio",
      title: "Laboratorio de Ciberseguridad",
      titleColored: "Ciberseguridad",
      subtitle:
        "Herramientas, scripts de automatización Linux, algoritmos de criptografía y prácticas de pruebas de seguridad.",
      viewRepo: "Ver Repositorio",
      explore: "Explorar",
      cards: {
        kaliTitle: "Automatización Kali Linux",
        kaliDesc:
          "Scripts Shell para mantenimiento automatizado, actualización de paquetes y configuración de entornos de auditoría en Kali Linux.",
        cryptoTitle: "Criptografía Go",
        cryptoDesc:
          "Algoritmos criptográficos, hashing seguro y conceptos de clave pública/privada en Golang.",
        osintTitle: "Panel OSINT",
        osintDesc:
          "Automatización para la recolección de inteligencia de fuentes abiertas en entornos Linux.",
        appsecTitle: "AppSec",
        appsecDesc:
          "OWASP Top 10, sanitización de entradas, prevención de SQLi/XSS y autenticación segura JWT/OAuth.",
        netTitle: "Networking",
        netDesc:
          "TCP/IP, análisis de paquetes con Wireshark, permisos de sistema y control de acceso en Linux.",
      },
    },
    footer: {
      comment1: "/* contacto */",
      comment2: "¿conversamos?",
      bio: "Full-Stack Developer & Especialista en Soporte TI. Enfocado en soluciones robustas en Golang, TypeScript y Ciberseguridad.",
      status: "DISPONIBLE PARA OPORTUNIDADES",
      directContact: "Contacto Directo",
      location: "Brasilia, DF — Brasil",
      networksLinks: "Redes y Enlaces",
      backToTop: "Volver Arriba",
      rights: "Samuel Barbosa. Todos los derechos reservados.",
    },
    terminal: {
      placeholder: "escribe un comando...",
      btnTooltip: "Presiona /",
      btnAria: "Abrir terminal",
      title: "samuel@kali:~ (Terminal)",
      welcomeTitle: "SAMUEL.OS v4.19-kali — Terminal Interactivo",
      welcomeMsg: 'Escribe "help" para ver los comandos disponibles.',
      commands: {
        help: "Mostrar comandos disponibles",
        whoami: "Quién es Samuel Barbosa",
        projetos: "Ir a la sección de proyectos",
        seguranca: "Ir a la sección de seguridad",
        skills: "Ir a stack y habilidades",
        experiencia: "Ir a experiencia",
        contato: "Ir a contacto",
        github: "Abrir GitHub",
        linkedin: "Abrir LinkedIn",
        clear: "Limpiar terminal",
      },
      navMessages: {
        projetos: "[+] Navegando a la sección de proyectos...",
        seguranca: "[+] Navegando a Cyber Lab...",
        skills: "[+] Navegando a Stack y Habilidades...",
        experiencia: "[+] Navegando a Experiencia...",
        contato: "[+] Navegando a Contacto...",
        github: "[+] Abriendo GitHub... github.com/SamuelBarbosa1",
        linkedin: "[+] Abriendo LinkedIn...",
      },
      easterEggPermission: "🔓 [SUDO] ¡Permiso concedido!",
      easterEggBanner: "🎉 ¡ACCESO CONCEDIDO CON ÉXITO! 🎉",
      easterEggText1: "Samuel Barbosa está disponible para",
      easterEggText2: "nuevas oportunidades en Full-Stack",
      easterEggText3: "Development & Cybersecurity.",
      easterEggRedirect: "Redireccionando a contacto...",
      notFound: '[-] Comando no encontrado: ',
      typeHelp: '    Escribe "help" para ver los comandos disponibles.',
    },
  },
};

export default translations;
